// 578prod-com/frontend/src/lib/catalogRules.js
export const KINDS = ["digital", "other"];

export function newProductDefaults(allowedKinds = KINDS) {
  const kinds = allowedKinds?.length ? allowedKinds : KINDS;
  return {
    kind: kinds[0],
    format: "",
    storeId: "",
    checkoutUrl: "",
    buttonUrl: "",
    name: "New Product",
    description: "",
    accent: "amber",
    buttonLabel: "",
  };
}

export function checkoutUrlForProduct(product) {
  if (!product) return "";
  return product.checkoutUrl || product.buttonUrl || "";
}

export function isFreeDigital(product) {
  if (!product || product.kind !== "digital") return false;
  return !product.storeId && !checkoutUrlForProduct(product);
}

export function validateProduct({ product, store, allowedKinds }) {
  const errors = [];
  const name = product?.name || "Untitled product";
  if (!KINDS.includes(product?.kind)) {
    errors.push(`${name}: kind must be digital or other`);
    return errors;
  }
  if (!allowedKinds?.includes(product.kind)) {
    errors.push(`${name}: kind ${product.kind} is not allowed on this site`);
  }
  if (product.storeId) {
    if (!store) {
      errors.push(`${name}: store ${product.storeId} was not found`);
    } else if (store.kind !== product.kind) {
      errors.push(`${name}: product kind and store kind must be the same kind`);
    }
  }
  const url = checkoutUrlForProduct(product);
  if (url && !url.startsWith("https://")) {
    errors.push(`${name}: checkout URL must start with https://`);
  }
  return errors;
}

export function validatePublish(products, storesById, allowedKinds) {
  const errors = [];
  for (const product of products || []) {
    const store = product.storeId ? storesById[product.storeId] : null;
    errors.push(...validateProduct({ product, store, allowedKinds }));
    if (product.kind === "digital" && !isFreeDigital(product) && !checkoutUrlForProduct(product).startsWith("https://")) {
      errors.push(`${product.name || "Untitled product"}: paid digital products need an https checkout URL`);
    }
  }
  return errors;
}
